import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';
import { USER_GROUPS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/user_groups_actions';
import {
	USER_GROUPS_FOR_MEMBER_TARGET_COLLECTION,
	USER_GROUPS_INDEX_TARGET_COLLECTION,
	USER_GROUPS_PICKER_TARGET_COLLECTION,
} from '../types/user_groups';

const initialState: any = standardInitialStateGenerator([
	// Backs the admin "User Groups" index table.
	USER_GROUPS_INDEX_TARGET_COLLECTION,
	// Backs the User Groups picker in the invite / edit user modals: every group in the tenant,
	// plus the groups the edited user is already in. Both must be registered here — the
	// fetchSuccess reducer reads `oldState[targetCollectionName].sorting`, so an unregistered
	// collection name throws instead of quietly no-oping.
	USER_GROUPS_PICKER_TARGET_COLLECTION,
	USER_GROUPS_FOR_MEMBER_TARGET_COLLECTION,
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
